<div class="wrapper" cdkScrollable [ngClass]="{ 'wrapper--mobile': isMobile$ | async }">
  <header class="header">
    <h1 class="mat-headline-1 bold" [ngClass]="{ 'mat-headline-4': isMobile$ | async }">
      {{ 'WM_TECH.LANDING.TITLE' | translate }}
    </h1>

    <p class="mat-h2 header-description">
      {{ 'WM_TECH.LANDING.DESCRIPTION' | translate }}
    </p>
  </header>

  <div class="animation">
    <img [ngClass]="{ 'animate-down': scrollDown }" src="../../../assets/images/landing/p1.png" [style]="(isDarkMode$ | async) ? 'filter: invert(1)' : ''" />
    <img [ngClass]="{ 'animate-up': scrollDown }" src="../../../assets/images/landing/p2.png" />
    <img [ngClass]="{ 'animate-down': scrollDown }" src="../../../assets/images/landing/windmill.png" />
    <img [ngClass]="{ 'rotate-left animate-down': scrollDown }" src="../../../assets/images/landing/windmill_square.png" />
    <img [ngClass]="{ 'animate-left': scrollDown }" src="../../../assets/images/landing/cloud-left.png" />
    <img [ngClass]="{ 'animate-right': scrollDown }" src="../../../assets/images/landing/cloud-right.png" />
    <img [ngClass]="{ 'animate-cloud-down': scrollDown }" src="../../../assets/images/landing/cloud-top.png" />
    <img [ngClass]="{ 'animate-up': scrollDown }" src="../../../assets/images/landing/windmill.png" />
    <img [ngClass]="{ 'rotate-left-big': scrollDown }" src="../../../assets/images/landing/windmill_square.png" />
    <img [ngClass]="{ opacity: scrollDown }" src="../../../assets/images/landing/coub.png" />
    <img [ngClass]="{ 'coin-down': scrollDown }" src="../../../assets/images/landing/coin.svg" [style]="(isDarkMode$ | async) ? 'filter: invert(1); opacity: 0.6' : ''" />
  </div>

  <div class="container-small">
    <mat-card class="main__list">
      <h2 class="mat-headline-2" [ngClass]="{ 'mat-headline-4': isMobile$ | async }">
        {{ 'WM_TECH.LANDING.ADVANTAGES_MMS.TITLE' | translate | uppercase }}
      </h2>
      <h3 class="mat-subtitle-1">
        {{ 'WM_TECH.LANDING.ADVANTAGES_MMS.DESCRIPTION' | translate }}
      </h3>

      <div class="adv-container">
        <ul>
          <li *ngFor="let advantage of advantages_mms">
            <div class="icons">
              <img src="../../../assets/images/landing/adv-mms/list-{{ advantage.id }}.svg" alt="{{ advantage.alt }}" class="big" [style]="(isDarkMode$ | async) ? 'filter: invert(1)' : ''" />
              <svg class="small" width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.2 3L6.812 11.387L3 7.575" stroke="#57d374" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <article class="text-block">
              <h4 class="bold uppercase">{{ advantage.title | translate }}</h4>
              <p class="mat-body-1">{{ advantage.text | translate }}</p>
            </article>
          </li>
        </ul>
        <a class="adv__button adv__button--first" mat-raised-button color="mms-button-bg-primary" (click)="redirect('mms')">{{ 'WM_TECH.LANDING.MANAGE' | translate }}</a>
      </div>
      <h2 class="mat-headline-2" [ngClass]="{ 'mat-headline-4': isMobile$ | async }">
        {{ 'WM_TECH.LANDING.ADVANTAGES_POOL.TITLE' | translate | uppercase }}
      </h2>
      <h3 class="mat-subtitle-1">
        {{ 'WM_TECH.LANDING.ADVANTAGES_POOL.DESCRIPTION' | translate }}
      </h3>
      <div class="adv-container">
        <ul>
          <li *ngFor="let advantage of advantages_pool">
            <div class="icons">
              <img src="../../../assets/images/landing/adv-pool/list-{{ advantage.id }}.svg" alt="{{ advantage.alt }}" class="big" [style]="(isDarkMode$ | async) ? 'filter: invert(1)' : ''" />
              <svg class="small" width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.2 3L6.812 11.387L3 7.575" stroke="#B991FF" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <article class="text-block">
              <h4 class="bold uppercase">{{ advantage.title | translate }}</h4>
              <p class="mat-body-1">{{ advantage.text | translate }}</p>
            </article>
          </li>
        </ul>

        <a class="adv__button" mat-raised-button color="pool-button-bg-primary" (click)="redirect('pool')">{{ 'WM_TECH.LANDING.POOL' | translate }}</a>
      </div>
    </mat-card>
  </div>

  <section class="partners container-medium" *ngIf="initLoaded">
    <app-partners></app-partners>
  </section>
</div>
